import { Injectable } from '@angular/core';
import { Conversiontype } from './conversiontype';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ConversiontypeService {
  baseUrl: string = environment.serviceUrl;

  constructor(private httpClient: HttpClient) {
  }

  Get(): Observable<Conversiontype[]> {
    return this.httpClient.get<Conversiontype[]>(this.baseUrl + 'api/ConversiontypeApi')
  }
  Post(conversiontype: Conversiontype): Observable<any> {

    let header = new HttpHeaders();
    header = header.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post(this.baseUrl + 'api/ConversiontypeApi/add', conversiontype, { headers: header, observe: 'response' })
  }
  Delete(conversiontype: Conversiontype) {
    let header = new HttpHeaders();
    header = header.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post(this.baseUrl + 'api/ConversiontypeApi/activeordeactive', conversiontype, { headers: header, observe: 'response' })
  }
  Put(conversiontype: Conversiontype): Observable<any> {
    let header = new HttpHeaders();
    header = header.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.put(this.baseUrl + 'api/ConversiontypeApi/Update', conversiontype, { headers: header, observe: 'response' })
  }


}
